import { useCallback, useState } from "react";

const useFeedModals = () => {
  const [shareData, setShareData] = useState(null);
  const [attachmentData, setAttachmentData] = useState(null);
  const [editPostId, setEditPostId] = useState(0); 
  const [reportPostId, setReportPostId] = useState(0); 
  const [blockByPostId, setBlockByPostId] = useState(0);

  const showShare = useCallback((data = {}) => {
    setShareData(data);
  }, []);

  const hideShare = useCallback(() => {
    setShareData(null);
  }, []);

  const showAttachment = useCallback((data = {}) => {
    setAttachmentData(data);
  }, []);

  const hideAttachment = useCallback(() => {
    setAttachmentData(null);
  }, []);

  // Edit post functions 
  const showEditPost = useCallback((id) => {
    setEditPostId(id);
  }, []);

  const hideEditPost = useCallback(() => {
    setEditPostId(0);
  }, []);

  // Report Post options 
  const showReportPost = useCallback((id) => {
    setReportPostId(id);
  }, []);

  const hideReportPost = useCallback(() => {
    setReportPostId(0);
  }, []);

  const showBlock = useCallback((id) => {
    setBlockByPostId(id);
  }, []);
  const hideBlock = useCallback(() => {
    setBlockByPostId(0);
  }, []);

  return {
    shareData,
    showShare,
    hideShare,
    attachmentData,
    showAttachment,
    hideAttachment,
    editPostId,
    showEditPost,
    hideEditPost,
    showReportPost,
    hideReportPost,
    reportPostId,
    showBlock,
    hideBlock, 
    blockByPostId
  };
};

export default useFeedModals;
